<template>
  <FormBody :number="2">
    <div class="container">
      <p>
        Если вы еще не собрали необходимые документы, посмотрите,
        как это сделать, или просто сообщите об убытке,
        а документы дошлите позднее
      </p>

      <form @submit.prevent="onSubmit" ref="mainForm" enctype="multipart/form-data" :class="SurvivalMode?'column-form':undefined">
        <input type="hidden" name="MAX_FILE_SIZE" value="2000000">

        <div v-show="!SurvivalMode"  class="form-group">
          <label class="form-label">Страховой продукт*</label>
          <CustomSelect name="product" @initialize="onInitialize" @itemSelected="onItemSelected">
            <option v-if="SurvivalMode" data-component="Survival" value="Survival">Дожитие</option>
            <option v-if="!SurvivalMode" data-component="LifeAndHealthInsurance" value="LifeAndHealthInsurance" >Страхование жизни и здоровья заемщика кредита</option>
            <option v-if="!SurvivalMode" data-component="GroupInsurance" value="GroupInsurance" >Страхование сотрудников группы</option>
            <option v-if="!SurvivalMode" data-component="LifeAndHealthInsurance" value="MortgageLifeInsurance">Комплексное ипотечное страхование жизни</option>
            <option v-if="!SurvivalMode" data-component="PropertyDamage" value="PropertyDamage">Гибель или повреждение застрахованного имущества по комплексному ипотечному страхованию</option>
            <option v-if="!SurvivalMode" data-component="MortgageTitleInsurance" value="MortgageTitleInsurance">Комплексное ипотечное страхование титула</option>
            <option v-if="!SurvivalMode" data-component="GAPInsurance" value="GAPInsurance">GAP-страхование</option>
            <option v-if="!SurvivalMode" data-component="GAPInsurance" value="RisksUnderControl">Риски под контролем</option>
            <option v-if="!SurvivalMode" data-component="PersonalProtection" value="PersonalProtection">Моя личная защита</option>
            <option v-if="!SurvivalMode" data-component="PurchaseProtection" value="PurchaseProtection">Защита покупки</option>
            <option v-if="!SurvivalMode" data-component="BankCardProtection" value="BankCardProtection">Моя защищенная карта</option>
            <option v-if="!SurvivalMode" data-component="WeatherInTheHouse" value="WeatherInTheHouse">Погода в доме</option>
            <option v-if="!SurvivalMode" data-component="JobLossInsurance" value="JobLossInsurance">Страхование от потери работы</option>
            <option v-if="!SurvivalMode" data-component="MaximumProtection" value="MaximumProtection">Моя максимальная защита</option>
            <option v-if="!SurvivalMode" data-component="Anticrisis" value="Anticrisis">«Антикризис», «Антикризис +», «Максимум» </option>
            <option v-if="!SurvivalMode" data-component="Barrier" value="Barrier">Барьерный</option>
            <option v-if="!SurvivalMode" data-component="SafeHome" value="SafeHome">Мой надежный дом</option>
          </CustomSelect>
        </div>
<!--        нужно показыать блок если выбрали Дожитие Survival-->
<!--        <div class="form-group" >-->
<!--          <CustomSelect name="product" @initialize="onInitialize" @itemSelected="onItemSelected">-->
<!--            <option data-component="PremierInvest" value="PremierInvest">Премьер Инвест</option>-->
<!--            <option data-component="PremierFuture" value="PremierFuture">Премьер Будущее</option>-->
<!--            <option data-component="PremierLife" value="PremierLife">Премьер Лайф</option>-->
<!--          </CustomSelect>-->
<!--        </div>-->

        <InputWithLabel
            type="date"
            placeholder="дд.мм.гггг"
            max="2100-12-31"
            name="eventDate"
            :errors="v$.eventDate.$errors"
            v-model="eventDate"
            @blur="v$.eventDate.$touch"
            scroll-into-view-if-errors
        >
          Дата наступления страхового события*
        </InputWithLabel>

        <hr>

        <component :is="component" :changedOrder="(component == 'Survival' && SurvivalMode)?true:undefined"></component>

        <UploadFiles/>

        <div class="checkbox-group">
          <div class="label-checkbox-pair">
            <input id="agree" name="agree" type="checkbox" v-model="agree" @click="onAgreeChange">
            <label for="agree">Я ознакомился с политикой обработки персональных данных (ПД) и даю согласие на обработку ПД.</label>
            <input type="hidden" :value="agree">
          </div>
        </div>
        <vue-recaptcha v-model="captchaPassed" />
        <div class="feedback-buttons-wrap">
          <router-link :to="{name : 'home'}" class="feedback__back">Назад</router-link>
          <button type="submit" :class="{'feedback__button': true, 'feedback__button-disabled': notReadyToSend}" :disabled="notReadyToSend">Отправить</button>
        </div>
      </form>
    </div>
  </FormBody>
</template>

<script>
import FormBody from "@/components/utils/FormBody";
import {mapGetters} from "vuex";
import LifeAndHealthInsurance from "@/components/insurances/LifeAndHealthInsurance/LifeAndHealthInsurance";
import GroupInsurance from "@/components/insurances/GroupInsurance/GroupInsurance";
import * as mns from "@/store/mutation-types";
import PropertyDamage from "@/components/insurances/PropertyDamage/PropertyDamage";
import MortgageTitleInsurance from "@/components/insurances/MortgageTitleInsurance/MortgageTitleInsurance";
import GAPInsurance from "@/components/insurances/GAPInsurance/GAPInsurance";
import PersonalProtection from "@/components/insurances/PersonalProtection/PersonalProtection";
import PremierInvest from "@/components/insurances/PremierInvest/PremierInvest";
import PremierLife from "@/components/insurances/PremierLife/PremierLife";
import PurchaseProtection from "@/components/insurances/PurchaseProtection/PurchaseProtection";
import BankCardProtection from "@/components/insurances/BankCardProtection/BankCardProtection";
import WeatherInTheHouse from "@/components/insurances/WeatherInTheHouse/WeatherInTheHouse";
import JobLossInsurance from "@/components/insurances/JobLossInsurance/JobLossInsurance";
import MaximumProtection from "@/components/insurances/MaximumProtection/MaximumProtection";
import Anticrisis from "@/components/insurances/Anticrisis/Anticrisis";
import Barrier from "@/components/insurances/Barrier/Barrier";
import SafeHome from "@/components/insurances/SafeHome/SafeHome";
import useVuelidate from "@vuelidate/core";
import {helpers} from "@vuelidate/validators";
import {dateGreaterThan, dateLessThenCurrent, dateRequired} from "@/validators/date-validators";
import UploadFiles from "@/components/utils/UploadFiles";
import {checked} from "@/validators/checkbox-validators";
import InputWithLabel from "@/components/utils/InputWithLabel";
import CustomSelect from "@/components/utils/CustomSelect";
import Survival from "@/components/insurances/Survival/Survival";
import sendForm from '@/mixins/sendForm';
import VueRecaptcha from '@/components/utils/VueRecaptcha.vue';

export default {
  anotherNameLife: "InsuredEventClaim",
  mixins: [sendForm],
  components: {
    Survival,
    InputWithLabel, UploadFiles,
    CustomSelect, FormBody, LifeAndHealthInsurance, GroupInsurance,
    PropertyDamage, MortgageTitleInsurance, GAPInsurance,
    PersonalProtection, PremierInvest, PremierLife,
    PurchaseProtection, BankCardProtection, WeatherInTheHouse,
    JobLossInsurance, MaximumProtection, Anticrisis, Barrier,
    SafeHome, VueRecaptcha
  },
  data(){
    return {
      v$: useVuelidate(),
      captchaPassed: false,
      SurvivalMode: false
    };
  },
  watch: {
    'v$.$silentErrors': function (errors) {
      if(this.agree && errors.length > 0){
        this.agree = false;
      }
    }
  },
  validations(){
    return {
      eventDate: {
        dateLessThenCurrent: helpers.withMessage('Дата не может быть больше, чем текущая', dateLessThenCurrent),
        dateGreaterThan: helpers.withMessage('Дата не может быть меньше 19.05.2016', dateGreaterThan(2016, 5, 19)),
        dateRequired: helpers.withMessage('Поле должно быть заполнено', dateRequired)
      },
      agree: {
        checked,
      }
    };
  },
  computed: {
    ...mapGetters(['component',]),
    notReadyToSend(){
      return !this.agree || !this.captchaPassed || this.waitResponse
    },
    eventDate: {
      get(){
        return this.$store.getters.date;
      },
      set(value){
        this.$store.commit(mns.SET_DATE, value);
      }
    },
    agree: {
      get(){
        return this.$store.getters.agree;
      },
      set(value){
        this.$store.commit(mns.SET_AGREE, value);
      }
    },
    checkboxDisabled(){
      return !(this.v$.$silentErrors.length in [0, 1]);
    },
  },
  methods: {
    onInitialize(event){
      this.$store.commit(mns.SET_INSURANCE_PRODUCT, event.getValue().value);
      this.$store.commit(mns.SET_COMPONENT, event.getValue().customProperties.component);
    },
    onItemSelected(event){
      const choice = event.detail.choice;

      this.$store.commit(mns.SET_INSURANCE_PRODUCT, choice.value);
      this.$store.commit(mns.SET_COMPONENT, choice.customProperties.component);
    },
    onAgreeChange(){
      if(!this.agree){
        this.v$.$touch();

        let firstElementWithError = this.v$.$silentErrors[0];

        if(firstElementWithError){
          document
              .getElementsByName(firstElementWithError.$property)[0]
              .scrollIntoView({behavior: "smooth", block: "center", inline: "center"});
        } // if.
      } // if.
    },
    onSubmit(){
      if(this.v$.$error)
        return;

      const mainForm = this.$refs.mainForm;

      this.sendForm('send-new-request-emails', mainForm)

      this.$router.push({name :'RequestSent'});
    },
  },
  beforeMount(){
    let ps = localStorage.getItem('params')
    if (ps) 
      this.SurvivalMode = JSON.parse(ps).SurvivalMode
  }
}
</script>

<style scoped>
  .container{
    padding: 25px 50px;
  }

  .feedback-buttons-wrap{
    display: flex;
    margin: 40px auto;
    flex-wrap: wrap;
  }

  .feedback__back{
    height: 45px!important;
    padding: 0!important;
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    border-radius: 5px;
    border: 1px solid #e60028;
    -webkit-box-flex: 0;
    flex: 0 0 25%;
    margin: 0 10px 0 0!important;
    position: relative;
    color: #333;
    z-index: 1;
    overflow: hidden;
    -webkit-transition: all .5s;
    transition: all .5s;
  }
  .feedback__button{
    background: #e60028;
    height: 45px!important;
    margin: 0!important;
    padding: 0!important;
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-flex: 1;
    flex: 1 1 auto;
    border-radius: 5px;
    border: 1px solid transparent;
    color: #fff;
  }

  .feedback__button-disabled{
    background: #fc6270;
  }
</style>
<style>
  .column-form{
    display: flex;
    flex-direction: column;
  }
  .column-form > *{
    width: 100%;
  }
  .column-form hr{
    margin-top: -9px;
  }
  .column-form ul:empty{
    display: none;
  }
  .column-form input[type=date]~ul{
    margin-bottom: 5px;
  }
  .column-form input[type=date]~ul:last-child{
    margin-bottom: 0;
  }
  .column-form .attach{
    margin-bottom: 10px;
  }
</style>